import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { StoreData } from '../reducers/typings'
import { ICampaign } from './typings'
import { getCampaigns } from './api'

const campaignAdapter = createEntityAdapter<ICampaign>({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
})

export const initialState = campaignAdapter.getInitialState()

const sources = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCampaigns.pending, (state) => {
      campaignAdapter.removeAll(state)
    })
    builder.addCase(getCampaigns.fulfilled, (state, { payload }) =>
      campaignAdapter.setAll(state, payload),
    )
  },
})

export default sources.reducer

export const { selectAll: selectAllCampaigns, selectById: selectCampaignById } =
  campaignAdapter.getSelectors<StoreData>((state) => state.campaigns)

export const activeCampaigns = (
  sources: ICampaign[],
  campaignRequired: boolean,
): ICampaign[] => {
  //If Campaign is an optional setting, then insert the "No campaign selected" as the first option item
  if (!campaignRequired) {
    const temp: ICampaign = {
      id: '0',
      name: '< No campaign selected >',
      description: 'No campaign selected',
      source: '< No source selected >',
      active: true,
    }
    sources.unshift(temp)
  }

  return sources.filter((p) => p.active && p.name != '')
}
